import { ReactComponent } from './number-2-xl.svg';
export const Number2IconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-2-xl.js.map